/* eslint-disable nonblock-statement-body-position */
import xdsToken from 'services/xdsToken';
import {
  fetchWithTimeout,
  logDebug,
  retrieveData,
} from 'utils/AuxiliarFunctions';

function catchError(err, from) {
  logDebug(`ERROR in elasticRequests: ${from}: `, err);
  switch (parseInt(err.message, 10)) {
    case 500:
      return 'internal_error';
    case 504:
      return 'timeout';
    case 400:
      return 'bad_request';
    case 401:
      return 'unauthorized';
    case 403:
      return 'forbidden';
    case 404:
    case 410:
      return 'not_found';
    case 409:
      return 'conflict';
    default:
      return 'network_error';
  }
}

async function PatientLink({ filter }) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;

  let url = `${domain}/elasticsearch/connector_patient_link/_search?size=1000&sort=@timestamp:desc`;
  if (filter) url = `${url}&q=(${filter})`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  const request = {
    method: 'GET',
    headers: myHeaders,
  };

  // logDebug('requestPRINTADO :>> ', request);
  const elasticResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'Connector audit'));

  if (typeof elasticResponse === 'string') return elasticResponse;

  const responseJson = await elasticResponse.json();
  return responseJson;
}

async function ConnectorAudit({ filter }) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;

  let url = `${domain}/elasticsearch/connector_audit/_search?size=100&sort=@timestamp:desc`;
  if (filter) url = `${url}&q=${filter}`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  const request = {
    method: 'GET',
    headers: myHeaders,
  };

  // logDebug('requestPRINTADO :>> ', request);
  const elasticResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'Connector audit'));

  if (typeof elasticResponse === 'string') return elasticResponse;

  const responseJson = await elasticResponse.json();
  return responseJson;
}

async function ConnectorAuditPost({
  localIds,
  cnes,
  model,
  status,
  startDate,
  endDate,
}) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;
  const url = `${domain}/elasticsearch/connector_audit/_search`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  // Construir a query do Elasticsearch
  const query = {
    sort: [
      {
        '@timestamp': {
          order: 'desc',
        },
      },
    ],
    size: 1000,
    // Retornar apenas os campos necessários para reduzir o tamanho da resposta
    _source: ['cnes', 'local_id', 'status', 'model', 'instance', '@timestamp'],
    query: {
      bool: {
        must: [],
      },
    },
  };

  // Adicionar filtros conforme necessário
  if (cnes) {
    query.query.bool.must.push({
      term: { cnes },
    });
  }

  if (model) {
    query.query.bool.must.push({
      term: { model },
    });
  }

  if (status) {
    query.query.bool.must.push({
      term: { status },
    });
  }

  // Adicionar filtro de data se fornecido
  if (startDate || endDate) {
    const rangeFilter = {
      range: {
        '@timestamp': {},
      },
    };

    if (startDate) {
      rangeFilter.range['@timestamp'].gte = startDate;
    }

    if (endDate) {
      rangeFilter.range['@timestamp'].lte = endDate;
    }

    query.query.bool.must.push(rangeFilter);
  }

  // Adicionar filtro de local_id se fornecido
  if (localIds && localIds.length > 0) {
    const shouldTerms = localIds.map((id) => ({
      term: { local_id: id },
    }));

    query.query.bool.must.push({
      bool: {
        should: shouldTerms,
      },
    });
  }

  const request = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(query),
  };

  // logDebug('requestPRINTADO :>> ', request);
  const elasticResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'ConnectorAuditPost'));

  if (typeof elasticResponse === 'string') return elasticResponse;

  const responseJson = await elasticResponse.json();
  return responseJson;
}

async function Api_AGHU({ filter }) {
  const domain = process.env.REACT_APP_ENDPOINT_XDSB_domain;

  let url = `${domain}/elasticsearch/api_exame_aghu/_search?size=100&sort=@timestamp:desc`;
  if (filter) url = `${url}&q=${filter}`;

  await xdsToken.getBearerToken();
  const token = await retrieveData('token');
  const applicationToken = await retrieveData('application_token');

  if (!token) return 'missing_token';

  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${applicationToken}`);
  myHeaders.append('Accept-Encoding', 'gzip,deflate');
  myHeaders.append('Accept', 'application/json');
  myHeaders.append('Content-type', 'application/json');

  const request = {
    method: 'GET',
    headers: myHeaders,
  };

  // logDebug('requestPRINTADO :>> ', request);
  const elasticResponse = await fetchWithTimeout(url, request)
    .then((response) => {
      if (response.status < 200 || response.status > 299)
        throw new Error(response.status);
      return response;
    })
    .catch((err) => catchError(err, 'Connector audit'));

  if (typeof elasticResponse === 'string') return elasticResponse;

  const responseJson = await elasticResponse.json();
  return responseJson;
}

export const elasticRequests = {
  PatientLink,
  ConnectorAudit,
  ConnectorAuditPost,
  Api_AGHU,
};
